// PrivateRoute.tsx in v6
import { useSelector } from 'react-redux';
import { Navigate, Route, useLocation } from 'react-router-dom';
import IgniteNavBar from "./IgniteNavBar";
import IgniteFooter from "./IgniteFooter";

const NavRoute = ({ children }) => {
  return (
    <div>
      <IgniteNavBar />
      {children}
      <IgniteFooter />
    </div>
  ) 
};

export default NavRoute;